import {
  CreateContextProvider,
  Form,
  SaveButton,
  useCreateController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import { Button as MUIButton, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Resources } from '../../resource';
import TypeConfigForm from './TypeConfigForm';
import { createAmountRange, RedPacketType } from '../../../services/redpacketService';
import { useFormContext } from 'react-hook-form';
import { PermissionButton } from '../../../../../routes/components/permission-button';

const CreateTypeConfig = ({
  typeFilter,
  onClose,
}: {
  typeFilter: RedPacketType;
  onClose: () => void;
}) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  //admin-react component useCreateController hook
  const controller = useCreateController({
    resource: Resources.redpacket,
    mutationOptions: {
      onSuccess: () => {
        notify(t('module.redpacket.createdSuccessfully'), { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        notify(error.message || t('module.redpacket.creationFailed'), { type: 'error' });
      },
    },
  });

  const CustomSaveButton = () => {
    const { handleSubmit } = useFormContext();
    const onSubmit = async (data: any) => {
      try {
        const resp = await createAmountRange({
          redPacketType: data.redPacketType || typeFilter,
          minAmount: String(data.minAmount),
          maxAmount: String(data.maxAmount),
          skewFactor: data.skewFactor,
          description: data.description,
        });
        const respAny = resp as any;
        if (respAny?.errors && respAny.errors.length > 0) {
          throw new Error(respAny.errors[0]?.message );
        }
        notify(t('module.redpacket.createdSuccessfully'), { type: 'success' });
        refresh();
        onClose();
      } catch (error: any) {
        notify(error.message || t('module.redpacket.creationFailed'), { type: 'error' });
      }
    };
    return <MUIButton onClick={handleSubmit(onSubmit)}>{t('actions.save')}</MUIButton>;
  };

  return (
    <CreateContextProvider value={controller}>
      <Form disableInvalidFormNotification>
        <DialogTitle>{t("module.redpacket.createRedPacketTypeConfiguration")}</DialogTitle>
        <DialogContent>
          <TypeConfigForm isCreate typeFilter={typeFilter} />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="redpacket" action="create">
            <CustomSaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </CreateContextProvider>
  );
};

export default CreateTypeConfig;
